exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__modal___2cM9s .btn-info {\n  background-color: #46cba0;\n  border-color: #46cba0; }\n  .style__modal___2cM9s .btn-info:hover {\n    background-color: #40bd94;\n    border-color: #40bd94; }\n\n.style__cancel___151HQ {\n  position: absolute;\n  left: 90px;\n  bottom: 24px;\n  height: 34px;\n  padding-right: 12px;\n  padding-left: 12px;\n  min-width: 70px; }\n", ""]);

// exports
exports.locals = {
	"modal": "style__modal___2cM9s",
	"cancel": "style__cancel___151HQ"
};